<template>
  <section>
    <div v-if="loading">
      <div class="grid grid-cols-12 mt-8">
        <div class="col-span-6 lg:col-span-6 xxl:col-span-6">
          <h2 class="intro-y text-lg font-medium mr-auto my-2">
            Cotizaciones Desarrollos ({{ filteredDevelopments.length }})
          </h2>
        </div>
        <div
          class="col-span-6 sm:w-auto flex justify-end mb-4"
          v-if="[1].includes(user.role)"
        >
          <a
            data-target="#development"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Agregar</a
          >
        </div>
        <div
          class="col-span-2 lg:col-span-12 xxl:col-span-12 grid grid-cols-6 gap-5"
        >
          <div
            class="hover:bg-theme-1 hover:text-white cursor-pointer border border-gray-400 px-2 py-1 w-full font-bold text-center rounded"
            v-for="item in status"
            :key="item.name"
            @click="setFilter(item.name)"
            :class="
              item.name === filter.status ? 'bg-theme-1 text-white' : 'bg-white'
            "
          >
            {{ item.name }}
          </div>
          <div
            class="hover:bg-theme-1 hover:text-white cursor-pointer border border-gray-400 px-2 py-1 w-full font-bold text-center rounded"
            @click="setFilter(null)"
            :class="filter.status == '' ? 'bg-theme-1 text-white' : 'bg-white'"
          >
            Todos
          </div>
        </div>
      </div>

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Editar</h2>
        </div>
        <form @submit.prevent="updateDevelopment">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-6 sm:col-span-6">
              <label>Titulo:</label>
              <input
                v-on:input="updateValue('title', $event)"
                type="text"
                class="input w-full border mt-2 flex-1"
                :value="development.title"
                required
                :disabled="user.role != 1 ? '' : disabled"
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Cuenta</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-on:input="updateValue('account_id', $event)"
                :value="development.account_id"
                :disabled="user.role != 1 ? '' : disabled"
                required
              >
                <option disabled>Seleccione la cuenta</option>
                <option
                  v-for="account in accounts"
                  v-bind:key="account.id"
                  v-bind:value="account.id"
                >
                  {{ account.name }} - {{ account.country.prefix }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6" v-if="user.role == 1">
              <label>Horas:</label>
              <input
                v-on:input="updateValue('hours', $event)"
                type="number"
                class="input w-full border mt-2 flex-1"
                :value="development.hours"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6" v-if="user.role == 1">
              <label>Fecha:</label>
              <input
                v-on:input="updateValue('date', $event)"
                type="date"
                class="input w-full border mt-2 flex-1"
                :value="development.date"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Estado</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-on:input="updateValue('status', $event)"
                :value="development.status"
                required
              >
                <option disabled>Seleccione la cuenta</option>
                <option
                  v-for="status in status"
                  v-bind:key="status.name"
                  v-bind:value="status.name"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Observaciones</label>
              <textarea
                class="input w-full border mt-2 flex-1"
                v-on:input="updateValue('observations', $event)"
                :value="development.observations"
              >
              </textarea>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              v-on:click="closeEditDevelopment()"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="update"
            >
              Modificar
            </button>
          </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
        <div
          class="intro-y col-span-12 sm:col-span-12 md:col-span-12 xxl:col-span-12"
          v-bind:key="development.id"
          v-for="development in filteredDevelopments"
        >
          <div
            class="file box rounded-md py-3 px-5 sm:px-8 relative zoom-in flex justify-between"
          >
            <div class="uppercase my-auto w-1/3">
              {{ development.title }}
            </div>
            <div class="my-auto w-48">
              {{ development.account.name }} -
              {{ development.account.country.prefix }}
            </div>
            <div
              class="text-xs my-auto font-bold"
              v-if="[1].includes(user.role)"
            >
              {{ development.hours }}
            </div>
            <div class="text-gray-600 text-xs text-wrap mt-2 font-bold w-24">
              <span class="border border-gray-200 p-2 rounded">
                {{ development.status }}
              </span>
            </div>
            <div class="text-gray-600 text-xs my-auto font-bold">
              {{ development.observations }}
            </div>
            <div class="text-gray-600 text-xs text-wrap mt-2">
              {{ development.date }}
            </div>
            <div
              class="absolute top-0 right-0 mr-2 mt-4 dropdown ml-auto"
              v-if="[1, 5].includes(user.role)"
            >
              <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
                <app-icon
                  v-bind:name="'more-vertical'"
                  v-bind:classname="'w-5 h-5 text-gray-500'"
                ></app-icon>
              </a>
              <div class="dropdown-box mt-5 absolute w-40 top-0 right-0 z-10">
                <div class="dropdown-box__content box p-2">
                  <a
                    v-on:click="editDevelopment(development)"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon
                      v-bind:name="'edit'"
                      v-bind:classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Editar
                  </a>
                  <a
                    v-if="[1].includes(user.role)"
                    v-on:click="removeDevelopment(development)"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon
                      v-bind:name="'trash'"
                      v-bind:classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Eliminar
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else />

    <!-- Modal -->
    <div class="modal" id="development">
      <div class="modal__content modal__content--md">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Agregar</h2>
        </div>
        <form @submit.prevent="createDevelopment">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
              <label>Titulo</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="development.title"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Cuenta</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="development.account_id"
                required
              >
                <option disabled>Seleccione la cuenta</option>
                <option
                  v-for="account in accounts"
                  v-bind:key="account.id"
                  v-bind:value="account.id"
                >
                  {{ account.name }} - {{ account.country.prefix }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Horas</label>
              <input
                type="number"
                class="input w-full border mt-2 flex-1"
                v-model="development.hours"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Fecha</label>
              <input
                type="date"
                class="input w-full border mt-2 flex-1"
                v-model="development.date"
                required
              />
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Crear
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'ListDevelopments',
  data() {
    return {
      loading: false,
      boxedit: false,
      development: this.defineDevelopment(),
      developments: null,
      status: null,
      development_current: {},
      filter: {
        status: 'En cotización',
      },
    }
  },
  beforeMount() {
    this.getItems()
    this.getList('account').then(() => {
      this.loading = true
    })
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      accounts: 'getAccounts',
    }),
    filteredDevelopments: function () {
      return this.developments.filter((item) => {
        let status = this.filter.status
          ? item.status === this.filter.status
          : true

        return status
      })
    },
  },
  methods: {
    async getItems() {
      this.loading = false
      try {
        const { list, status_get } = await this.get(`/development`)
        this.developments = list
        this.status = status_get
        //console.log(this.user)
        this.loading = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    defineDevelopment() {
      return {
        title: '',
        account_id: '',
        hours: '',
        date: '',
        status: '',
        observations: '',
        entity: 'development',
      }
    },
    createDevelopment() {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.post(vm.development)
        .then((item) => {
          window.$('#development').modal('hide')
          vm.defineDevelopment()
          vm.loading = true
          window.$('#create').button('reset')
          window.location.reload()
        })
        .catch((error) => {
          window.$('#create').button('reset')
          vm.defineDevelopment()
          vm.loading = true
        })
    },
    editDevelopment: function (value) {
      this.boxedit = true
      this.development = value
    },
    closeEditDevelopment: function () {
      this.boxedit = false
      this.development_current = {}
    },
    updateValue(attribute, e) {
      this.development_current[attribute] = e.target.value
    },
    updateDevelopment() {
      var vm = this
      vm.loading = false

      vm.development_current.id = vm.development.id
      vm.development_current.entity = 'development'
      //console.log(vm.development_current)
      vm.put(vm.development_current)
        .then((item) => {
          this.closeEditDevelopment()
          vm.defineDevelopment()
          vm.loading = true
          window.location.reload()
        })
        .catch((error) => {
          vm.defineDevelopment()
          vm.loading = true
        })
    },
    removeDevelopment: function (value) {
      var vm = this
      vm.form = {
        id: value.id,
        entity: 'development',
      }
      vm.deleteItem(vm.form)
        .then((item) => {
          vm.loading = true
          window.location.reload()
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    setFilter(value) {
      //console.log(value)
      this.filter.status = value
      //this.getItems()
    },
    ...mapActions(['get', 'post', 'put', 'deleteItem', 'getList']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ListDevelopments.vue?0ddf9bce